// src/App.jsx
import React, { useEffect } from "react";
import { Provider, useSelector } from "react-redux";
import RoutesComponent from "./Routes";
import useAuth from "./hooks/useAuth";
import { store } from "./app/store";
import { LanguageProvider } from "./hooks/LanguageContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./config/msalConfig";
import { UnitProvider } from "./hooks/UnitProvider";
import { setAppInsightsUserContext } from "./AppInsights"; // ✅ import helper

const AppContent = ({ isAuthenticated, login, logout, loading }) => {
  const profileData = useSelector((state) => state.profile?.profileData);

  useEffect(() => {
    if (profileData?.userName || profileData?.coachId) {
      setAppInsightsUserContext(profileData.displayName, profileData.coachId);
    }
  }, [profileData]);

  return (
    <>
      <ToastContainer />
      <RoutesComponent
        isAuthenticated={isAuthenticated}
        login={login}
        logout={logout}
        loading={loading}
      />
    </>
  );
};

const App = () => {
  const { isAuthenticated, login, logout, loading } = useAuth();
  const msalInstance = new PublicClientApplication(msalConfig);

  return (
    <MsalProvider instance={msalInstance}>
      <LanguageProvider>
        <Provider store={store}>
          <UnitProvider>
            <AppContent
              isAuthenticated={isAuthenticated}
              login={login}
              logout={logout}
              loading={loading}
            />
          </UnitProvider>
        </Provider>
      </LanguageProvider>
    </MsalProvider>
  );
};

export default App;
